// extracted by mini-css-extract-plugin
module.exports = {"private":"PrivateTag_private__FUzoy","icon":"PrivateTag_icon__3M9tA"};